import { render, staticRenderFns } from "./TextAlignmentSetter.vue?vue&type=template&id=0990c9b2&"
import script from "./TextAlignmentSetter.vue?vue&type=script&lang=js&"
export * from "./TextAlignmentSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TextAlignmentSetter.vue"
export default component.exports